import { render, staticRenderFns } from "./AddManagementForm.vue?vue&type=template&id=5d598774&scoped=true"
import script from "./AddManagementForm.vue?vue&type=script&lang=js"
export * from "./AddManagementForm.vue?vue&type=script&lang=js"
import style0 from "./AddManagementForm.vue?vue&type=style&index=0&id=5d598774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d598774",
  null
  
)

export default component.exports